import { useLocation, useNavigate } from "react-router-dom";
import {useCallback, useEffect, useState} from "react";
import ArcButton, {ButtonType} from "app/components/arc/ArcButton";
import {UserMenuModel} from "app/model/ua/user-menu";
import {useAppDispatch, useAppSelector} from "app/store/hook";
import {setCurrentMenu} from "app/reducers/menuSlice";

export default function MenuItem(props: any) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const currentPageMenu = useAppSelector(state => state.menus.currentMenu);
  const url = location.pathname;
  const [menuActivated, setMenuActivated] = useState<string>();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const onClickMenu = (item: any) => {
    if (item.menuId == menuActivated && !item.subMenus && item.subMenus?.length > 0) {
      setIsOpen(!isOpen);
      return;
    }

    setMenuActivated(item.menuId);
    setIsOpen(true);
    if (item.menuUrlAddr && item.menuUrlAddr != "") {
      // 전체메뉴는 화면이 바뀌면 Header 가 닫는다
      dispatch(setCurrentMenu({ currentMenu: item }));
      navigate(item.menuUrlAddr);
    }
  };

  useEffect(() => {
    if(props.menus && props.menus.length > 0) {
      const activeMenu = findHasActiveChild(props.menus, location.pathname);
      if(activeMenu) {
        dispatch(setCurrentMenu({ currentMenu: activeMenu }));
      }
    }
  }, [location.pathname, props.menus]);

  useEffect(() => {
    if(currentPageMenu) {
      const parentMenu = props.menus?.find((menu: UserMenuModel) => menu.menuId === currentPageMenu.uppoMenuId);
      if(parentMenu) {
        setMenuActivated(parentMenu.menuId)
      }
    }
  }, [currentPageMenu]);

  const itemHasChildren = useCallback((item: UserMenuModel) => {
    const hasActiveChildrenMenu = !!findHasActiveChild(item.subMenus??[], url);
    const shouldOpenByActive = props.openActiveMenu !== false && hasActiveChildrenMenu;
    return (
      <li key={item.menuId} className={"dep" + (menuActivated != item.menuId ? "" : (isOpen || shouldOpenByActive) ? " open" : " ")}>
        <ArcButton type={ButtonType.custom}
                   text={item.menuNm}
                   onClick={() => onClickMenu(item)} />
        {<MenuItem onClickMenu={onClickMenu} lev={props.lev + 1} menus={item.subMenus} display={(isOpen || shouldOpenByActive) && menuActivated == item.menuId ? "block" : "none"} openActiveMenu={props.openActiveMenu} />}
      </li>
    )
  }, [menuActivated, isOpen, props.lev, props.openActiveMenu, url]);

  const itemHasNoChildren = useCallback((item: UserMenuModel) => {
    return (
      <li key={item.menuId} className={(url.includes(item.menuUrlAddr ?? '') ? "ov active" : "")}>
        <ArcButton type={ButtonType.custom}
                   text={item.menuNm}
                   onClick={() => onClickMenu(item)} />
      </li>
    );
  }, [url]);

  function findHasActiveChild(subMenus: UserMenuModel[], pathname: string) {
    let active: UserMenuModel|null = null;
    for(const menu of subMenus) {
      if(menu.menuUrlAddr === pathname) {
        active = menu;
        break;
      } else {
        findHasActiveChild(menu.subMenus??[], pathname);
      }
    }
    return active;
  }

  return (
    <div className={`depth0${props.lev}`} style={{ display: props.display }}>
      <ul>
        {props.menus?.map((item: any) => (
          item.subMenus?.length > 0 ? itemHasChildren(item) : itemHasNoChildren(item)
        ))}
      </ul>
    </div>
  );
}
